import React, { PropsWithChildren } from 'react'
import { SmartWidget, SmartWidgetProvider } from '@workwhile/ui'
import { ShiftAnalysisScreen } from '../components/ShiftAnalysisScreen/ShiftAnalysisScreen'
import { RootScreen } from '../components/RootScreen'

const MAX_WIDGET_WIDTH = 368

export const ShiftIntelligenceWidgetProvider = ({
  children,
}: PropsWithChildren) => {
  return (
    <SmartWidgetProvider
      groups={[
        <SmartWidget.Group
          path="select-filters"
          maxWidth={MAX_WIDGET_WIDTH}
          key="select-filters"
        >
          <RootScreen />
        </SmartWidget.Group>,
        <SmartWidget.Group
          path="shift-analysis"
          maxWidth={MAX_WIDGET_WIDTH}
          key="shift-analysis"
        >
          <ShiftAnalysisScreen />
        </SmartWidget.Group>,
      ]}
    >
      {children}
    </SmartWidgetProvider>
  )
}
